import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import ChangeCorporationPassword
                                                    from "../../../application/usecase/corporation/ChangeCorporationPassword";
import GetCorporation                               from "../../../application/usecase/corporation/GetCorporation";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import PasswordChangeButton                         from "../../components/common/PasswordChangeButton";
import CorporationSettingForm                       from "../../components/setting/corporation/CorporationSettingForm";
import CorporationUpdateButton                      from "../../components/setting/corporation/CorporationUpdateButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  getCorporation: GetCorporation;
  changeCorporationPassword: ChangeCorporationPassword;
}

class CorporationContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "法人情報"
    };
    super(props, state)
  }

  protected componentDidMountInternal(): void {
    this.props.getCorporation.execute();
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "法人情報",
                path: "/corporation"
              },
            ]
          }/>
        </TopSection>

        <TopSection>
          <CorporationUpdateButton/>
          <PasswordChangeButton
            onClick={ (currentPassword, newPassword, confirmPassword, callback) => this.props.changeCorporationPassword.execute(currentPassword, newPassword, confirmPassword, callback) }
          />
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <CorporationSettingForm/>

        <BottomSection>
          <CorporationUpdateButton/>
          <BackHistoryButton path="/setting"/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getCorporation: new GetCorporation(dispatch),
  changeCorporationPassword: new ChangeCorporationPassword(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CorporationContainer);
